<ng-container *ngIf="!item.hidden">

    <div class="group-title" [ngClass]="item.classes">
        <span class="hint-text">{{item.id | translate : null : item.title}}</span>
    </div>

</ng-container>
